function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { InsetStack } from '../../Stack/InsetStack';
//import { Modal } from '../../Modal';
import { IconButton, Modal } from 'office-ui-fabric-react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SectionContainer = _ref => {
  let {
    padding = '0px 15px 15px 15px',
    children,
    disableScroll,
    enableFullScreen
  } = _ref;
  const [fullScreen, setFullScreen] = React.useState(false);
  const rootStyles = {
    padding: padding,
    margin: 0,
    height: '100%',
    overflowX: disableScroll ? undefined : 'hidden',
    overflowY: disableScroll ? undefined : 'scroll'
  };
  if (fullScreen) {
    return /*#__PURE__*/_jsx(Modal, {
      isOpen: fullScreen,
      onDismiss: () => {
        setFullScreen(false);
      },
      styles: {
        root: {
          height: '100%',
          width: '100%'
        },
        main: {
          height: '100%',
          width: '100%'
        },
        scrollableContent: {
          height: '100%',
          width: '100%'
        }
      },
      children: /*#__PURE__*/_jsxs(InsetStack, {
        styles: {
          root: rootStyles
        },
        children: [enableFullScreen && /*#__PURE__*/_jsx(IconButton, {
          iconProps: {
            iconName: 'ChromeClose'
          },
          styles: {
            root: {
              position: 'absolute',
              top: 2,
              right: 0
            }
          },
          onClick: () => {
            setFullScreen(false);
          }
        }), children]
      })
    });
  }
  return /*#__PURE__*/_jsxs(InsetStack, {
    styles: {
      root: _objectSpread(_objectSpread({}, rootStyles), {
        position: 'relative'
      })
    },
    children: [enableFullScreen && /*#__PURE__*/_jsx(IconButton, {
      iconProps: {
        iconName: 'FullScreen'
      },
      styles: {
        root: {
          position: 'absolute',
          top: 2,
          right: 0
        }
      },
      onClick: () => {
        setFullScreen(true);
      }
    }), children]
  });
};